import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import classnames from 'classnames';

import { AppConfig } from '../../core-bundle/config/app-config';

import Actions from '@app/store/action';
import NotificationCategories from '@app/constant/notification-categories';

const BASE_CLASS_NAME = 'notificationbar';

class NotificationBar extends React.PureComponent {
  state = { hidden: false };

  componentDidMount() {
    this.showTimeout = setTimeout(this.hideNotification, this.props.duration);
  }

  componentWillUnmount() {
    clearTimeout(this.showTimeout);
    clearTimeout(this.hideTimeout);
  }

  hideNotification = () => {
    const { resetNotification } = this.props;

    this.setState({ hidden: true });

    this.hideTimeout = setTimeout(
      resetNotification,
      AppConfig.notification.animation_duration
    );
  };

  render() {
    const { category, html } = this.props;
    const { hidden } = this.state;

    const className = classnames(
      BASE_CLASS_NAME,
      `${BASE_CLASS_NAME}--${category}`,
      {
        [`${BASE_CLASS_NAME}--hidden`]: hidden,
      }
    );

    return (
      <div className={className}>
        <div
          className={`${BASE_CLASS_NAME}__text`}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    );
  }
}

NotificationBar.propTypes = {
  html: PropTypes.string,
  category: PropTypes.oneOf(Object.values(NotificationCategories)),
  duration: PropTypes.number,
  resetNotification: PropTypes.func,
};

NotificationBar.defaultProps = {
  category: NotificationCategories.default,
  duration: AppConfig.notification.duration,
  resetNotification: noop,
};

const mapStateToProps = ({
  notification: {
    panel: { category, html, duration },
  },
}) => ({ category, html, duration });

const mapDispatchToProps = {
  resetNotification: Actions.Notification.resetNotification,
};

export { NotificationBar };
export default connect(mapStateToProps, mapDispatchToProps)(NotificationBar);
